<template>
  <div>
    <div v-if="showDefaultCharges" class="default-charges">
      <div class="left-menu">
        <Menus :menu="menu" @menuClicked="menuClicked" />
      </div>
      <div class="right-tabulator">
        <TableBox
          title="Default Charges"
          :tableData.sync="defaultChargesTable"
          :selectedRow.sync="selectedDefaultCharges"
          :hideColumns="['ChgCode List']"
        />
      </div>

      <div v-if="showEQuotation" class="equotation-popup">
        <div class="equotation-content">
          <div class="top-section">
            <ButtonFilter
              filterPosition="right"
              buttonText="Change Filter"
              :filterWidth="300"
              :isOpen.sync="filterOpen"
            >
              <div class="filter-section">
                <Dropdown placeholder="From" />
                <BoxContainer title="Quotations">
                  <CheckBoxV2 title="All Quotations" />
                  <BoxContainer title="Quotation Range">
                    <DateTimePicker placeholder="From" />
                    <DateTimePicker placeholder="To" />
                  </BoxContainer>
                </BoxContainer>
                <button @click="refresheQuotation">Refresh</button>
              </div>
            </ButtonFilter>
            <div>Last Refreshed: {{ eQuotationLastRefreshed }}</div>
          </div>
          <div class="table-section">
            <TableBox
              title="eQuotation"
              :tableData.sync="equotationListing"
              :selectedRow.sync="selectedeQuotation"
              :hideColumns="['quotationno', 'portloadcode', 'portdischargecode', 'finaldestcode']"
              :maxSelection="1"
            />
          </div>
          <div class="bottom-section">
            <button @click="sendeQuotation">Send</button>
            <button @click="accepteQuotation">Accept</button>
            <button class="cancel-btn" @click="showEQuotation = false">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showReportsHome" class="quotation-main">
      <ReportsHomeV2
        title="Quotation"
        placeholder="Quotation No"
        :sections="quotationSection"
        :inputValue.sync="freeTextQuotation"
        :inputDisabled="true"
        @generateReport="generateReport"
        :designerV3="true"
        :designerV3ReportFiles="designerV3ReportFile"
        :designerV3ReportData="designerV3Data"
        :jsReport="false"
      >
        <div class="Details_Quotation" slot="Details_Quotation Details">
          <div class="Details_New">
            <button v-if="action == 'N'" @click="resetQuotationDetailsInput">Reset</button>
            <button v-if="action == 'N'" @click="draftPopUp = !draftPopUp">Load Draft</button>
          </div>
          <BoxContainer title="Quotation #" :isCollapsible="true">
            <div style="display: flex; flex-direction: row" class="Quo-Cus">
              <InputQuery
                placeholder="Quotation #"
                :items="quotationList"
                itemKey="Quotation #"
                :selectedObject.sync="selectedQuotation"
                :search.sync="freeTextQuotation"
                :errorMessage.sync="quotationnoError"
                :isDisabled="true"
                style="max-width: 200px; min-width: 200px; padding: 5px"
                :isRequired="true"
                :showDesc="false"
              />
              <InputQuery
                placeholder="Customer"
                :items="customerList"
                itemKey="Code - Description"
                :selectedObject.sync="selectedCustomer"
                :search.sync="freeTextCustomer"
                :errorMessage.sync="customercodeError"
                :isDisabled="action == 'E' || viewMode || referenceNo != ''"
                @focusChanged="quotationCaptionLostFocus($event, 'freeTextCustomer')"
                style="max-width: 300px; min-width: 300px"
              />
            </div>
            <div style="display: flex; flex-direction: row; justify-content: space-between">
              <Input
                placeholder="POD"
                :inputValue.sync="pod"
                validator="text,5"
                :errorMessage.sync="podError"
                :isDisabled="action == 'E' || viewMode || referenceNo != ''"
                @focusChanged="quotationCaptionLostFocus($event, 'pod')"
                style="max-width: 120px; min-width: 100px; padding: 5px"
              />
              <Input
                placeholder="Cargo Type"
                :inputValue.sync="cargotype"
                validator="text,5"
                :errorMessage.sync="cargotypeError"
                :isDisabled="action == 'E' || viewMode || referenceNo != ''"
                @focusChanged="quotationCaptionLostFocus($event, 'cargotype')"
                style="max-width: 120px; min-width: 100px; padding: 5px"
              />
              <Input
                placeholder="Size"
                :inputValue.sync="size"
                validator="text,2"
                :errorMessage.sync="sizeError"
                :isDisabled="action == 'E' || viewMode || referenceNo != ''"
                @focusChanged="quotationCaptionLostFocus($event, 'size')"
                style="max-width: 120px; min-width: 100px; padding: 5px"
              />
              <Input
                placeholder="Extra"
                :inputValue.sync="extra"
                validator="text,3"
                :errorMessage.sync="extraError"
                :isDisabled="action == 'E' || viewMode || referenceNo != ''"
                @focusChanged="quotationCaptionLostFocus($event, 'extra')"
                style="max-width: 120px; min-width: 100px; padding: 5px"
              />
            </div>
          </BoxContainer>
          <div v-if="showAdditionalDetails">
            <BoxContainer title="Additional Details" :isCollapsible="true">
              <div style="display: flex; flex-direction: row; justify-content: space-between">
                <div style="width: 150px"
                  ><DateTimePicker
                    placeholder="Date"
                    :showTime="false"
                    :value.sync="quotationDate"
                    :isDisabled="viewMode"
                /></div>
                <div style="width: 200px"
                  ><Input placeholder="Reference #" :inputValue.sync="referenceNo" :isDisabled="true"
                /></div>
                <div style="width: 70px"
                  ><Input placeholder="Revision #" :inputValue.sync="revisionNo" :isDisabled="true"
                /></div>
              </div>
              <div style="display: flex; flex-direction: row">
                <div
                  ><Input placeholder="Container Type" :inputValue.sync="containerType" :isDisabled="viewMode"
                /></div>
                <div style="margin-left: 10px"
                  ><CheckBoxV2 title="DG Cargo" :isChecked.sync="dgCargo" :isDisabled="viewMode"
                /></div>
              </div>
              <div style="display: flex; flex-direction: row">
                <div
                  ><Dropdown
                    placeholder="Incoterm"
                    :items="incotermList"
                    itemKey="Incoterm"
                    :selectedObject.sync="selectedIncoterm"
                    :isDisabled="viewMode"
                /></div>
                <div style="margin-left: 10px"
                  ><Input placeholder="Freetime" :inputValue.sync="freetime" :isDisabled="viewMode"
                /></div>
              </div>
              <InputQuery
                placeholder="POL"
                :items="polList"
                itemKey="Port Code"
                descKey="Port Location"
                :selectedObject.sync="selectedPOL"
                :isDisabled="viewMode"
              />
              <InputQuery
                placeholder="POD"
                :items="podList"
                itemKey="Port Code"
                descKey="Port Location"
                :selectedObject.sync="selectedPOD"
                :isDisabled="viewMode"
              />
              <InputQuery
                placeholder="Final Destination"
                :items="finalDestinationList"
                itemKey="Port Code"
                descKey="Port Location"
                :selectedObject.sync="selectedFinalDestination"
                :isDisabled="viewMode"
              />
              <Input placeholder="Carrier" :inputValue.sync="carrier" :isDisabled="viewMode" />
              <Input placeholder="Note1" :inputValue.sync="note1" :isDisabled="viewMode" />
              <Input placeholder="Note2" :inputValue.sync="note2" :isDisabled="viewMode" />
              <Input placeholder="Note3" :inputValue.sync="note3" :isDisabled="viewMode" />
            </BoxContainer>
          </div>
          <RemarksBox :text.sync="remarks" :maxLength="200" :errorMessage="remarksError" :isDisabled="viewMode" />

          <div class="addDeleteButton">
            <button v-if="!viewMode" @click="chargesPopUpClick">+</button>
            <button v-if="!viewMode" @click="deletePopUpClick">-</button>
          </div>

          <div class="defaultChargesTable">
            <TableBox
              title="Default Charges"
              v-if="showDefaultChargesList"
              :tableData.sync="defaultChargesListWithoutDelete"
              :selectedRow.sync="selectedCharges"
              :hideColumns="['ID', 'SeqNo', 'Date Updated', 'indaction', 'Payable']"
              :additionalButtons="viewMode ? [] : defaultChargesEditButton"
              @buttonClicked="defaultChargesTableEditButtonClick"
            />
          </div>
          <div class="saveButton">
            <button v-if="action == 'N'" @click="draftSavePopUp = !draftSavePopUp">Save as Draft</button>
            <button v-if="!viewMode" @click="quotationSaveButtonClick">Save</button>
            <button @click="quotationCancelButtonClick">Cancel</button>
          </div>
        </div>
      </ReportsHomeV2>

      <PopupV2
        class="chargesPopUp"
        :show.sync="chargesPopUp"
        title="Charges Details"
        :buttons="chargesPopUpButton"
        @buttonClicked="chargesButtonClick"
        height="650px"
        width="400px"
      >
        <div class="chargesPopUp-Main">
          <Dropdown
            placeholder="Charges Code Type"
            :items="chargesCodeType"
            itemKey="type"
            :selectedObject.sync="selectedChargesType"
            @selected="chargesTypeSelected"
            :isDisabled="editDisabled"
          />
          <InputQuery
            placeholder="Charges Code"
            :items.sync="filteredChargesCodeList"
            itemKey="Code - Description"
            descKey="Description"
            :selectedObject.sync="selectedChargesCode"
            :isRequired="true"
            :allowFreeText="false"
            :errorMessage.sync="chargecodeError"
            :isDisabled="editDisabled"
          />
          <Input
            placeholder="Qty"
            :inputValue.sync="qty"
            @focusChanged="qtyBuySellLostFocus($event, 'qty')"
            :isRequired="true"
            :errorMessage.sync="qtyError"
            validator="positiveInteger,7"
          />
          <InputQuery
            placeholder="Currency"
            :items="currencyList"
            itemKey="Currency Code"
            descKey="Description"
            :selectedObject.sync="selectedCurrency"
            :allowFreeText="false"
          />
          <InputQuery
            placeholder="UOM"
            :items="uomList"
            itemKey="UOM Code - Description"
            descKey="Description"
            :selectedObject.sync="selectedUOM"
            :allowFreeText="false"
          />
          <Dropdown
            placeholder="UOM Type"
            :items="uomTypeList"
            itemKey="UOMType"
            :selectedObject.sync="selectedUOMType"
            :errorMessage.sync="uomtypeError"
            :allowFreeText="true"
          />
          <div class="uomRangeFromTo">
            <p class="uomRange">UOM Range</p>
            <div class="uomFromTo">
              <div>
                <Input placeholder="From" :inputValue.sync="uomRangeFrom" :errorMessage.sync="uomrangeError"/>
              </div>
              <div>
                <Input placeholder="To" :inputValue.sync="uomRangeTo" :errorMessage.sync="uomrangeError"/>
              </div>
            </div>
          </div>
          <div class="buySell">
            <div class="popupBuying">
              <p class="buying">Buying</p>
              <Input
                placeholder="U. Price"
                :inputValue.sync="buyingUPrice"
                validator="positiveDecimal,,4"
                :errorMessage.sync="buyingUPriceError"
                @focusChanged="qtyBuySellLostFocus($event, 'buyingUPrice')"
              />
              <Input
                placeholder="Total"
                :inputValue.sync="buying"
                :errorMessage.sync="buyingError"
                validator="positiveDecimal,,4"
                @focusChanged="qtyBuySellLostFocus($event, 'buying')"
              />
            </div>
            <div class="popupSelling">
              <p class="selling">Selling</p>
              <Input
                placeholder="U. Price"
                :inputValue.sync="sellingUPrice"
                :errorMessage.sync="sellingUPriceError"
                validator="positiveDecimal,,4"
                @focusChanged="qtyBuySellLostFocus($event, 'sellingUPrice')"
              />
              <Input
                placeholder="Total"
                :inputValue.sync="selling"
                :isRequired="true"
                :errorMessage.sync="sellingError"
                validator="positiveDecimal,,4"
                @focusChanged="qtyBuySellLostFocus($event, 'selling')"
              />
            </div>
          </div>
          <Dropdown
            placeholder="Payee Type"
            :items="payeeTypeList"
            itemKey="party_code"
            :selectedObject.sync="selectedPayeeType"
            :errorMessage.sync="payeetypeError"
          />
          <InputQuery
            placeholder="Payee Code"
            :items.sync="filteredPayeeCodeList"
            itemKey="Code - Description"
            descKey="Payee Name"
            :selectedObject.sync="selectedPayeeCode"
            :errorMessage.sync="payeecodeError"
            :isDisabled="!selectedPayeeType"
            :allowFreeText="false"
          />
          <div class="startEndValid">
            <p class="valid">Valid Date</p>
            <div class="validStartEnd">
              <div>
                <DateTimePicker placeholder="Start" :value.sync="startValidDate" :showTime="false" :popupUpwards="true" />
              </div>
              <div>
                <DateTimePicker placeholder="End" :value.sync="endValidDate" :showTime="false" :popupUpwards="true" />
              </div>
            </div>
          </div>
          <RemarksBox
            :maxLength="500"
            :text.sync="itemremarks"
            :errorMessage.sync="itemremarksError"
            style="max-height: 80px; min-height: 80px"
          />
        </div>
      </PopupV2>

      <PopupV2
        class="draftPopUp"
        :show.sync="draftPopUp"
        title="Draft List"
        :buttons="draftPopUpButton"
        @buttonClicked="draftButtonClick"
        height="450px"
      >
        <div class="draftPopUpBody">
          <Dropdown
            placeholder="Draft File Name"
            :items="draftList"
            :selectedObject.sync="selectedDraftLoadFile"
            itemKey="File Name"
            :isRequired="true"
            :errorMessage.sync="draftLoadFileNameError"
          />
        </div>
      </PopupV2>

      <PopupV2
        class="draftSavePopUp"
        :show.sync="draftSavePopUp"
        title="Save Draft"
        :buttons="draftSavePopUpButton"
        @buttonClicked="draftSaveButtonClick"
        height="450px"
        width="430px"
      >
        <div class="draftPopUpBody">
          <Input
            placeholder="Draft File Name"
            :inputValue.sync="draftFileName"
            :isRequired="true"
            :isDisabled="true"
            :errorMessage.sync="draftFileNameError"
          />
          <TableBox
            title="Draft Versions"
            :tableData="draftListHistory"
            :maxSelection="0"
            style="max-height: 200px"
            :columnWidth="draftVersionsColumnWidth"
          />
        </div>
      </PopupV2>
    </div>
  </div>
</template>

<script>
import ReportsHomeV2 from '@/pages/ReportsV2/ReportsHome';

export default {
  components: {
    ReportsHomeV2,
  },
  computed: {
    defaultChargesListWithoutDelete: function () {
      return this.defaultChargesList.filter((f) => {
        return f['indaction'] != 'D';
      });
    },
    draftVersionsColumnWidth: function () {
      if (!this.draftListHistory || this.draftListHistory.length === 0) {
        return [];
      }

      const arrayColumns = Object.keys(this.draftListHistory[0]);
      const numberOfColumns = arrayColumns.length;
      const result = Array.from({ length: numberOfColumns }, () => 180);

      const fileNameIndex = arrayColumns.indexOf('File Name');
      const lastModifiedIndex = arrayColumns.indexOf('Last Modified');
      const userIDIndex = arrayColumns.indexOf('User ID');
      result[fileNameIndex] = 130;
      result[lastModifiedIndex] = 150;
      result[userIDIndex] = 120;

      return result;
    },
  },
  data: function () {
    return {
      showDefaultCharges: true,
      showReportsHome: false,
      viewMode: false,
      headerImage: '',

      menu: [
        {
          title: 'New Default Charges',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png',
          enabled: false,
          key: 'MnuNew',
        },
        {
          title: 'Edit Default Charges',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          enabled: false,
          key: 'MnuEdit',
        },
        {
          title: 'Delete Default Charges',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png',
          enabled: false,
          key: 'MnuDelete',
        },
        {
          title: 'View/Print Default Charges',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png',
          enabled: false,
          key: 'MnuView',
        },
        {
          title: 'Duplicate Default Charges',
          icon: 'https://dsmlib.logistics.systems/Icons/DuplicateJob.png',
          enabled: false,
          key: 'MnuNew',
        },
        { 
          title: 'eQuotation', 
          icon: 'https://dsmlib.logistics.systems/Icons/eDN.png', 
          enabled: false, 
          visible: false,
          key: 'MnueQuot',
        },
      ],
      defaultChargesTable: [],
      selectedDefaultCharges: [],
      // action: '',

      quotationSection: [
        {
          name: 'Details',
          child: ['Quotation Details'],
          show: true,
        },
      ],
      quotationList: [],
      selectedQuotation: null,
      freeTextQuotation: '',
      quotationnoError: '',
      pod: '',
      podError: '',
      cargotype: '',
      cargotypeError: '',
      size: '',
      sizeError: '',
      extra: '',
      extraError: '',
      remarks: '',
      remarksError: '',
      customerList: [],
      selectedCustomer: null,
      freeTextCustomer: '',
      customercodeError: '',
      currencyList: [],
      selectedCurrency: null,
      chargesCodeType: [
        {
          type: 'Both',
          payable: '1',
        },
        {
          type: 'Income',
          payable: '0',
        },
        {
          type: 'Expenses',
          payable: '2',
        },
      ],
      selectedChargesType: {
        type: 'Both',
        payable: '1',
      },
      chargesCodeList: [],
      filteredChargesCodeList: [],
      selectedChargesCode: null,
      chargecodeError: '',
      uomList: [],
      selectedUOM: null,
      uomError: '',
      uomTypeList: [],
      selectedUOMType: null,
      uomtypeError: '',
      payeeTypeList: [],
      selectedPayeeType: null,
      payeetypeError: '',
      payeeCodeList: [],
      filteredPayeeCodeList: [],
      selectedPayeeCode: null,
      selectedEditPayeeCode: null, //have this variable due to watch keep resetting selectedPayeeCode to null after changed in Edit
      payeecodeError: '',
      qty: '1',
      qtyError: '',
      uomRangeFrom: '',
      uomRangeTo: '',
      uomrangeError: '',
      buyingUPrice: '0.00',
      buyingUPriceError: '',
      buying: '0.00',
      buyingError: '',
      sellingUPrice: '0.00',
      sellingUPriceError: '',
      selling: '0.00',
      sellingError: '',
      itemremarks: '',
      itemremarksError: '',
      startValidDate: null,
      endValidDate: null,
      seqNo: '',

      defaultChargesList: [], //#, chargescode, uom, uomtype, uomrange, qty, buying, selling, payeetype, payeecode, description, item remarks
      showDefaultChargesList: true,

      defaultChargesEditButton: [{ text: 'Edit', index: 0, width: 60 }],
      selectedCharges: [],
      selectedEditID: null,
      editDisabled: false,

      chargesPopUp: false,
      chargesPopUpButton: [{ text: 'Save' }, { text: 'Cancel', color: 'lightgray' }],
      draftPopUp: false,
      draftPopUpButton: [{ text: 'Load' }, { text: 'Cancel', color: 'lightgray' }],
      draftSavePopUp: false,
      draftSavePopUpButton: [{ text: 'Save' }, { text: 'Cancel', color: 'lightgray' }],

      draftList: [],
      draftFileName: '',
      draftFileNameError: '',
      selectedDraftLoadFile: null,
      draftLoadFileNameError: '',

      draftListHistory: [],

      currentQuotation: null,
      quotationDetails: [],
      action: '',

      showAdditionalDetails: false,
      quotationDate: null,
      referenceNo: '',
      revisionNo: '',
      containerType: '',
      dgCargo: false,
      incotermList: [],
      selectedIncoterm: null,
      polList: [],
      selectedPOL: null,
      podList: [],
      selectedPOD: null,
      finalDestinationList: [],
      selectedFinalDestination: null,
      carrier: '',
      note1: '',
      note2: '',
      note3: '',
      eQuoteShipmentDateFrom: null,
      eQuoteShipmentDateTo: null,

      showEQuotation: false,
      filterOpen: false,
      eQuotationLastRefreshed: '',
      equotationListing: [],
      selectedeQuotation: null,

      designerV3Data: null,
      designerV3ReportFile: null,
    };
  },
  props: {},
  methods: {
    async sasControlFunction() {
      this.$fullscreenLoading('Checking Security Access');
      const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=FMS&page=Default Charges`);
      sasControl.forEach((k) => {
        const selectedMenu = this.menu.filter((m) => m['key'] == k['Control']);
        selectedMenu?.forEach((m) => {
          m[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
        });
      });
      this.$fullscreenLoading('');
    },
    refreshClicked: async function () {
      this.$fullscreenLoading('Getting Data');
      this.defaultChargesTable = [];
      this.defaultChargesTable = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'DEFAULTCHARGES' });

      // await this.populateQuotationList();
      this.$fullscreenLoading('');
    },

    menuClicked: async function (item) {
      switch (item.title) {
        case 'New Default Charges':
          this.action = 'N';
          this.revisionNo = '0';
          this.showDefaultCharges = false;
          this.showReportsHome = true;
          break;
        case 'Edit Default Charges':
          this.action = 'E';
          if (this.selectedDefaultCharges.length == 0) {
            this.$showAlert('error', 'Edit Default Charges', 'Please select a record to edit');
            return;
          }

          this.selectedQuotation = this.quotationList.getSelected(
            this.selectedDefaultCharges[0]['Quotation #'],
            'Quotation #',
          );
          await this.populateQuotation(
            this.selectedDefaultCharges[0]['Quotation #'],
            this.selectedDefaultCharges[0]['Revision #'],
          );
          this.quotationDetailsJSONFormat();
          this.showDefaultCharges = false;
          this.showReportsHome = true;
          if (this.selectedQuotation) {
            this.freeTextQuotation = this.selectedQuotation['Quotation #']; 
            this.generateReport(); // to set designerV3Data and designerV3ReportFile, fix issue where report uses data from previous editing quotation
          }
          break;
        case 'Delete Default Charges': {
          this.action = 'D';
          if (this.selectedDefaultCharges.length == 0) {
            this.$showAlert('error', 'Delete Default Charges', 'Please select a default charges to delete.');
            return;
          }
          const confirmDelete = await this.$showAlert(
            'warning',
            'Delete Default Charges',
            `Are you sure you want to delete ${this.selectedDefaultCharges[0]['Quotation #']}?\nCharge Code: (${this.selectedDefaultCharges[0]['ChgCode List']})`,
            [{ text: 'Delete' }, { text: 'No' }],
          );
          if (confirmDelete === 'Delete') {
            const delJSON = {
              action: 'D',
              quotationno: this.selectedDefaultCharges[0]['Quotation #'],
              revisionno: this.selectedDefaultCharges[0]['Revision #'],
              system: 'FMS',
            };
            this.$fullscreenLoading('Deleting Default Charges');
            const delResult = await this.$apiCallV2('/Quotation/SaveQuotationCharges', delJSON);
            if (delResult) {
              if (delResult[0]['Results'] == 0) {
                this.$showAlert('info', 'Delete Default Charges', 'Default Charges Deleted.');
                this.selectedDefaultCharges = [];
                await this.refreshClicked();
              } else {
                this.$showAlert('error', 'Delete Default Charges', delResult[0]['ErrMsg']);
              }
            } else {
              this.$showAlert('error', 'Delete Default Charges', 'Unable to Delete Default Charges.');
            }
            this.$fullscreenLoading();
          }
          break;
        }
        case 'View/Print Default Charges':
          this.action = 'V';
          if (this.selectedDefaultCharges.length == 0) {
            this.$showAlert('error', 'View Default Charges', 'Please select a record to view');
            return;
          }

          this.selectedQuotation = this.quotationList.getSelected(
            this.selectedDefaultCharges[0]['Quotation #'],
            'Quotation #',
          );
          await this.populateQuotation(
            this.selectedDefaultCharges[0]['Quotation #'],
            this.selectedDefaultCharges[0]['Revision #'],
          );
          this.quotationDetailsJSONFormat();
          this.viewMode = true;
          this.showDefaultCharges = false;
          this.showReportsHome = true;
          if (this.selectedQuotation) {
            this.freeTextQuotation = this.selectedQuotation['Quotation #']; 
            this.generateReport(); // to set designerV3Data and designerV3ReportFile, fix issue where report uses data from previous editing quotation
          }
          break;
        case 'Duplicate Default Charges':
          this.action = 'N';
          if (this.selectedDefaultCharges.length == 0) {
            this.$showAlert('error', 'Duplicate Default Charges', 'Please select a record to duplicate');
            return;
          }

          await this.populateQuotation(
            this.selectedDefaultCharges[0]['Quotation #'],
            this.selectedDefaultCharges[0]['Revision #'],
          );
          this.referenceNo = ''; //duplicate will remove reference no(cannot have different quotation no with same reference no)
          this.revisionNo = '0'; //duplicate will set revision no to empty(new action so revision will reset to 0)
          this.quotationDetailsJSONFormat();
          this.showDefaultCharges = false;
          this.showReportsHome = true;
          this.freeTextQuotation = this.selectedDefaultCharges[0]['Quotation #']; 
          this.generateReport(); // to set designerV3Data and designerV3ReportFile, fix issue where report uses data from previous editing quotation
          break;
        case 'eQuotation':
          this.showEQuotation = true;
          this.refresheQuotation();
          break;
      }
    },

    populateData: function () {
      const populateDataPromise = [];
      populateDataPromise.push(this.populateQuotationList());

      populateDataPromise.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CUSTOMER' }).then((result) => {
          this.customerList = result;
          this.customerList.forEach((f) => (f['Code - Description'] = `${f['Customer Code']} - ${f['Customer Name']}`));
        }),
      );

      populateDataPromise.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CURRENCY' }).then((result) => {
          this.currencyList = result;
        }),
      );

      populateDataPromise.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'UOM' }).then((result) => {
          this.uomList = result;
          this.uomList = this.uomList.map((a) => {
            return {
              ...a,
              'UOM Code - Description': `${a['UOM Code']} - ${a['Description']}`,
            };
          });
        }),
      );

      populateDataPromise.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'UOMTYPE' }).then((result) => {
          this.uomTypeList = result;
        }),
      );

      populateDataPromise.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'PAYEETYPE' }).then((result) => {
          this.payeeTypeList = result;
        }),
      );

      this.selectedChargesType = this.chargesCodeType.find((f) => f['payable'] == '1');

      populateDataPromise.push(
        this.$apiCallV2('/Master/GetListMaster', {
          masterfile: 'CHARGESCODE',
          module: 'DEFCHARGES',
          jobtype: this.selectedChargesType['payable'],
        }).then((result) => {
          this.chargesCodeList = result;
          this.chargesCodeList.forEach((f) => (f['Code - Description'] = `${f['Charge Code']} - ${f['Description']}`));
          this.filteredChargesCodeList = this.chargesCodeList.filter(
            (f) => f['Payable'] == this.selectedChargesType['type'],
          );
        }),
      );

      populateDataPromise.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'incoterms' }).then((result) => {
          this.incotermList = result;
        }),
      );

      populateDataPromise.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'port' }).then((result) => {
          this.polList = result;
          this.podList = result;
          this.finalDestinationList = result;
        }),
      );

      populateDataPromise.push(
        this.$apiCallV2('/Login/GetDetails').then((result) => {
          const loginDetails = result;
          this.headerImage = loginDetails?.['CoHeaderFin'] ?? '';
        }),
      );

      populateDataPromise.push(this.populatePayeeList());

      return populateDataPromise;
    },

    populateQuotationList: async function () {
      this.quotationList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'QUOTATION', module: 'FMS' });
    },

    populatePayeeList: async function () {
      this.payeeCodeList = await this.$apiCallV2('/Quotation/GetChargesPayee', {});
      this.payeeCodeList.forEach((f) => (f['Code - Description'] = `${f['Payee Code']} - ${f['Payee Name']}`));
    },

    populateQuotation: async function (quotationNo, revisionNo) {
      this.$fullscreenLoading('Getting Quotation Details');
      this.quotationDetails = await this.$apiCallV2('/Quotation/GetDefaultCharges', {
        quotationno: quotationNo,
        revisionno: revisionNo,
      });
      this.populateFields();
      if (!(this.$route.params['action'] == 'N' && this.$route.params['quotationno'])) {
        this.extra = this.quotationDetails[0]['Extra'];
      }
      this.$fullscreenLoading();
    },

    populateDraft: async function (draft) {
      this.$fullscreenLoading('Getting Quotation Details');
      const result = await this.$apiCallV2('/Quotation/GetQuotationDraft', { get: 'file', filename: draft });
      this.quotationDetails = result['Content'];
      this.populateFields();
      this.extra = this.quotationDetails[0]['Extra'];
      this.$fullscreenLoading();
    },

    populateFields: function () {
      this.defaultChargesList = [];

      this.selectedCustomer = this.customerList.getSelected(this.quotationDetails[0]['Customer Code'], 'Customer Code');
      if (!this.selectedCustomer) {
        this.freeTextCustomer = this.quotationDetails[0]['Customer Code'];
      }
      this.pod = this.quotationDetails[0]['POD'];
      this.cargotype = this.quotationDetails[0]['Cargo Type'];
      this.size = this.quotationDetails[0]['Size'];
      this.remarks = this.quotationDetails[0]['Remarks'];

      this.quotationDate =
        this.quotationDetails[0]['Quotation Date'] ? new Date(this.quotationDetails[0]['Quotation Date']) : null;
      this.referenceNo = this.quotationDetails[0]['Reference No'] ?? '';
      this.revisionNo = this.quotationDetails[0]['Revision No'] ?? '';
      this.containerType = this.quotationDetails[0]['Container Code'] ?? '';
      this.dgCargo = this.quotationDetails[0]['DG Cargo'] ? this.quotationDetails[0]['DG Cargo'] == '1' : false;
      this.selectedIncoterm =
        this.quotationDetails[0]['Incoterm'] ?
          this.incotermList.getSelected(this.quotationDetails[0]['Incoterm'], 'Incoterm')
        : null;
      this.freetime = this.quotationDetails[0]['Freetime'];
      this.selectedPOL =
        this.quotationDetails[0]['Load Port'] ?
          this.polList.getSelected(this.quotationDetails[0]['Load Port'], 'Port Code')
        : null;
      this.selectedPOD =
        this.quotationDetails[0]['Discharge Port'] ?
          this.polList.getSelected(this.quotationDetails[0]['Discharge Port'], 'Port Code')
        : null;
      this.selectedFinalDestination =
        this.quotationDetails[0]['Final Dest'] ?
          this.polList.getSelected(this.quotationDetails[0]['Final Dest'], 'Port Code')
        : null;
      this.carrier = this.quotationDetails[0]['Carrier'] ?? '';
      this.note1 = this.quotationDetails[0]['Note1'] ?? '';
      this.note2 = this.quotationDetails[0]['Note2'] ?? '';
      this.note3 = this.quotationDetails[0]['Note3'] ?? '';

      this.defaultChargesList = this.quotationDetails[0]['DefaultChargesList'];

      if (this.defaultChargesList.length > 0) {
        let ID = 0;
        this.defaultChargesList.forEach((f) => {
          ID = ID + 1;
          f['ID'] = ID;
          f['Qty'] = parseFloat(f['Qty']).toString();
          f['indaction'] = this.action == 'N' ? 'N' : '';
        });
      }
    },
    chargesButtonClick: async function (e) {
      switch (e) {
        case 'Cancel':
          this.chargesPopUp = false;
          this.resetChargesInput();
          break;
        case 'Save': {
          const newDefaultChargesList = JSON.parse(JSON.stringify(this.defaultChargesList));

          let maxID = 0;
          if (this.defaultChargesList.map((i) => i['ID']).length > 0) {
            maxID = Math.max(...this.defaultChargesList.map((i) => i.ID)) + 1;
          } else {
            maxID = 1;
          }

          const chargesObject = {
            ID: this.selectedEditID ?? maxID,
            'Charge Code': this.selectedChargesCode?.['Charge Code'] ?? '',
            Description: this.selectedChargesCode?.['Description'] ?? '',
            Qty: this.qty ?? '',
            Currency: this.selectedCurrency?.['Currency Code'] ?? '',
            Buying: this.buying ?? '',
            Selling: this.selling ?? '',
            UOM: this.selectedUOM?.['UOM Code'] ?? '',
            'UOM Type': this.selectedUOMType?.['UOMType'] ?? '',
            'UOM Range': `${this.uomRangeFrom ?? ''}-${this.uomRangeTo ?? ''}`,
            'Payee Type': this.selectedPayeeType?.['party_code'] ?? '',
            'Payee Code': this.selectedPayeeCode?.['Payee Code'] ?? '',
            'Item Remarks': this.itemremarks ?? '',
            'Start Valid Date': this.startValidDate?.formatString('yyyy-MM-dd') ?? '',
            'End Valid Date': this.endValidDate?.formatString('yyyy-MM-dd') ?? '',
            SeqNo: this.seqNo ?? '',
            Payable: '1',
            'Date Updated': '',
            indaction: this.seqNo ? 'E' : 'N',
          };

          const tempChargesObject = JSON.parse(JSON.stringify(chargesObject));
          tempChargesObject['model'] = 'DefaultCharges';
          const tempJSON = this.convertKeysToLowerCase(tempChargesObject);

          this.$fullscreenLoading('Checking Default Charges data');
          const validity = await this.$apiCallV2('/Quotation/CheckDataValidity', tempJSON);

          this.$fullscreenLoading('');
          if (validity) {
            for (const error of validity['error']) {
              this[`${error['Key']}Error`] = error['Value'];
            }
            return;
          }
          let editIndex = -1;
          if (newDefaultChargesList.length > 0 && this.selectedEditID) {
            editIndex = newDefaultChargesList.findIndex((i) => i['ID'] == this.selectedEditID);
          }
          if (editIndex !== -1) {
            //0 count as falsy value
            newDefaultChargesList.splice(editIndex, 1, chargesObject);
          } else {
            newDefaultChargesList.push(chargesObject);
          }
          this.defaultChargesList = [];
          this.$nextTick(() => (this.defaultChargesList = JSON.parse(JSON.stringify(newDefaultChargesList))));

          this.chargesPopUp = false;
          break;
        }
      }
    },

    draftButtonClick: async function (e) {
      switch (e) {
        case 'Cancel':
          this.selectedDraftLoadFile = null;
          this.draftLoadFileNameError = '';
          this.draftPopUp = false;
          break;
        case 'Load':
          if (!this.selectedDraftLoadFile) {
            this.draftLoadFileNameError = 'Draft File Name is required!';
          } else {
            this.resetQuotationDetailsInput();
            await this.populateDraft(this.selectedDraftLoadFile['File Name']);
            this.quotationCaptionLostFocus(false);
            this.selectedDraftLoadFile = null;
            this.draftFileNameError = '';
            this.draftPopUp = false;
          }
          break;
      }
    },

    draftSaveButtonClick: async function (e) {
      switch (e) {
        case 'Cancel':
          this.draftFileName = '';
          this.draftFileNameError = '';
          this.draftSavePopUp = false;
          break;
        case 'Save':
          if (!this.draftFileName) {
            this.draftFileNameError = 'Draft File Name is required!';
          } else {
            let tempLatestVersion = 0;
            if (this.draftListHistory.length > 0) {
              const tempVersion = this.draftListHistory.map((a) => {
                return Number(a['File Name'].substring(a['File Name'].lastIndexOf('-') + 1).replace('v', ''));
                //return Number(a['name'].substring(a['name'].lastIndexOf("-") + 1).replace('v', ''));
              });
              tempLatestVersion = Math.max.apply(Math, tempVersion);
            } else {
              tempLatestVersion = 0;
            }
            this.draftFileName = `${this.draftFileName}-v${tempLatestVersion + 1}`;
            this.defaultChargesList.forEach((d) => {
              d['SeqNo'] = '';
              d['Date Updated'] = '';
            });
            const userDetails = await this.$apiCallV2(`/Login/GetDetails`);
            const newFileName = this.draftFileName.replace(/\//g, '');
            const DraftJSON = {
              DraftName: newFileName,
              'User ID': userDetails.LoginUserId,
              Content: [
                {
                  'Customer Code': this.selectedCustomer ? this.selectedCustomer['Customer Code'] : this.freeTextCustomer ?? '',
                  POD: this.pod ?? '',
                  'Cargo Type': this.cargotype ?? '',
                  Size: this.size ?? '',
                  Extra: this.extra ?? '',
                  Remarks: this.remarks ?? '',
                  'Quotation No': this.freeTextQuotation ?? '',
                  DefaultChargesList: this.defaultChargesList ?? [],
                },
              ],
            };

            const result = await this.$apiCallV2('/Quotation/SaveDraftQuotation', DraftJSON);
            this.$showAlert('info', 'Save Draft', result);
            this.draftFileName = '';
            this.draftFileNameError = '';
            this.draftSavePopUp = false;
          }
          break;
      }
    },

    quotationSaveButtonClick: async function () {
      if (this.action == 'N') {
        const checkQuotationNo = this.quotationList.getSelected(this.freeTextQuotation, 'Quotation #');
        if (checkQuotationNo) {
          await this.$showAlert('error', 'Quotation # Already Exists!', 'Please ensure Quotation # is unique');
          return;
        }
      }

      let tempAction = this.action;
      let tempRevisionNo = this.revisionNo;
      let tempDefaultChargesList = JSON.parse(JSON.stringify(this.defaultChargesList));

      if (tempAction == 'N') {
        this.tempRevisionNo = '';
      } else if (this.action == 'E') {
        const editAnswer = await this.$showAlert('info', 'Editing Quotation', `Do you want to save as new revision?`, [
          { text: 'Yes' },
          { text: 'No', color: 'gray', textColor: 'white' },
        ]);

        if (editAnswer == 'Yes') {
          tempAction = 'N';
          tempRevisionNo = '';

          //remove action D from the list since is saving to a new revision
          tempDefaultChargesList = JSON.parse(JSON.stringify(tempDefaultChargesList.filter(f => f['indaction'] != 'D')));
          tempDefaultChargesList.forEach((f) => {
            f['indaction'] = 'N';
          });
        }
      }

      let saveequotation = '0';
      let sendequotation = '0';
      if (this.referenceNo) {
        //if have reference no means is a equotation
        const saveAnswer = await this.$showAlert(
          'info',
          'Saving Quotation',
          `Do you want to save this Quotation #(${this.freeTextQuotation}) Revision to Reference #(${this.referenceNo})`,
          [
            { text: 'Save' },
            { text: 'Save and Send' },
            { text: 'No', color: 'red', textColor: 'white' },
            { text: 'Cancel', color: 'gray', textColor: 'white' },
          ],
        );

        if (saveAnswer == 'Cancel') {
          return;
        } else if (saveAnswer == 'Yes and Sent') {
          sendequotation = '1';
        }

        saveequotation = '1';
      }

      const saveJSON = {
        'Customer Code': this.selectedCustomer ? this.selectedCustomer['Customer Code'] : this.freeTextCustomer ?? '',
        POD: this.pod ?? '',
        'Cargo Type': this.cargotype ?? '',
        Size: this.size ?? '',
        Extra: this.extra ?? '',
        Remarks: this.remarks ?? '',
        'Quotation No': this.freeTextQuotation ?? '',
        quotationdate: this.quotationDate?.formatString('yyyy-MM-dd') ?? '',
        referenceno: this.referenceNo ?? '',
        containertype: this.containerType ?? '',
        dgcargo: this.dgCargo ? '1' : '0',
        incoterm: this.selectedIncoterm ? this.selectedIncoterm['Incoterm'] : '',
        freetime: this.freetime ?? '',
        ploading: this.selectedPOL ? this.selectedPOL['Port Code'] : '',
        pdischarge: this.selectedPOD ? this.selectedPOD['Port Code'] : '',
        fdestination: this.selectedFinalDestination ? this.selectedFinalDestination['Port Code'] : '',
        carrier: this.carrier ?? '',
        note1: this.note1 ?? '',
        note2: this.note2 ?? '',
        note3: this.note3 ?? '',
        revisionno: tempRevisionNo ?? '',
        Action: tempAction ?? 'N',
        System: 'FMS',
        saveequotation: saveequotation ?? '',
        DefaultChargesList: tempDefaultChargesList ?? [],
      };

      const mainBody = this.convertKeysToLowerCase(saveJSON);

      this.$fullscreenLoading('Checking Quotation data');
      const validity = await this.$apiCallV2('/Quotation/CheckDataValidity', mainBody);
      this.$fullscreenLoading('');
      if (validity) {
        for (const error of validity['error']) {
          this[`${error['Key']}Error`] = error['Value'];
        }
        return;
      }

      this.$fullscreenLoading('Saving data');
      if (mainBody['defaultchargeslist'].length > 0) {
        mainBody['defaultchargeslist'] = mainBody['defaultchargeslist'].filter((f) => f['indaction'] != '');
      }

      const saveResult = await this.$apiCallV2('/Quotation/SaveQuotationCharges', mainBody);
      if (saveResult) {
        if (saveResult[0]['Results'] == 0) {
          await this.$showAlert('info', 'Save Quotation', 'Quotation Saved.');

          //send eQuotation
          if (sendequotation == '1') {
            this.$nextTick(() => this.$loading('Sending eQuotation'));
            this.sendeQuotationAPI(this.referenceNo);
          }

          this.revisionNo = saveResult[0]['revisionno']; //put API revision no back to the variables
          this.showDefaultChargesList = false;
          this.viewMode = true;
          this.$nextTick(() => (this.showDefaultChargesList = true));
        } else {
          this.$showAlert('error', 'Save Quotation', saveResult[0]['ErrMsg']);
        }
      } else {
        this.$showAlert('error', 'Save Quotation', 'Unable to Save Quotation.');
      }
      //reload default charges and quotation list records
      await this.refreshClicked();

      this.$fullscreenLoading('');
    },

    convertKeysToLowerCase: function (object) {
      const convertedObject = {};
      for (const key of Object.keys(object)) {
        const lowerNonSpacedKey = key.replaceAll(' ', '').toLowerCase();
        if (Array.isArray(object[key])) {
          convertedObject[lowerNonSpacedKey] = object[key].map(this.convertKeysToLowerCase);
        } else if (typeof object[key] === 'object') {
          convertedObject[lowerNonSpacedKey] = this.convertKeysToLowerCase(object[key]);
        } else {
          convertedObject[lowerNonSpacedKey] = object[key];
        }
      }
      return convertedObject;
    },

    quotationCancelButtonClick: function () {
      this.showReportsHome = false;
      this.showDefaultCharges = true;
      this.resetQuotationDetailsInput();
      this.populateQuotationList();
      if (this.showEQuotation == true) {
        this.refresheQuotation();
      }

      this.action = '';
      this.viewMode = false;
    },

    resetChargesInput: function () {
      this.selectedEditID = null;
      this.editDisabled = false;
      this.selectedChargesCode = null;
      this.chargecodeError = '';
      this.selectedCurrency = null;
      this.selectedUOM = null;
      this.uomError = '';
      this.selectedUOMType = null;
      this.uomtypeError = '';
      this.uomRangeFrom = '';
      this.uomRangeTo = '';
      this.uomrangeError = '';
      this.qty = '1';
      this.qtyError = '';
      this.buyingUPrice = '';
      this.buying = '';
      this.sellingUPrice = '';
      this.selling = '';
      this.sellingError = '';
      this.selectedPayeeType = null;
      this.payeetypeError = '';
      this.selectedPayeeCode = null;
      this.selectedEditPayeeCode = null;
      this.payeecodeError = '';
      this.startValidDate = null;
      this.endValidDate = null;
      this.seqNo = '';
      this.itemremarks = '';
      this.itemremarksError = '';
    },

    resetQuotationDetailsInput: function () {
      this.selectedQuotation = null;
      this.freeTextQuotation = '';
      this.quotationnoError = '';
      this.selectedCustomer = null;
      this.freeTextCustomer = '';
      this.customercodeError = '';
      this.pod = '';
      this.podError = '';
      this.cargotype = '';
      this.cargotypeError = '';
      this.size = '';
      this.sizeError = '';
      this.extra = '';
      this.extraError = '';
      this.remarks = '';
      this.remarksError = '';

      //additional details
      this.quotationDate = null;
      this.referenceNo = '';
      this.revisionNo = '';
      this.containerType = '';
      this.dgCargo = false;
      this.selectedIncoterm = null;
      this.freetime = '';
      this.selectedPOL = null;
      this.selectedPOD = null;
      this.selectedFinalDestination = null;
      this.carrier = '';
      this.note1 = '';
      this.note2 = '';
      this.note3 = '';

      this.defaultChargesList = [];
    },

    loadDraftButtonClick: async function () {
      this.draftList = await this.$apiCallV2('/Quotation/GetQuotationDraft', { get: 'list' });
    },

    loadDraftFileHistory: async function () {
      this.draftListHistory = [];
      const tempDraftListHistory = await this.$apiCallV2('/Quotation/GetQuotationDraft', {
        get: 'historylist',
        filename: this.freeTextQuotation,
      });
      setTimeout(() => {
        this.draftListHistory = tempDraftListHistory;
      }, 500);
    },

    qtyBuySellLostFocus: function (state, currentData) {
      if (!state) {
        let val = this[currentData]; //use currentData value to aceess variable
        if (!val) {
          //if val is empty string or null then changed the value to default value
          if (currentData == 'qty') {
            val = '1';
          } else {
            val = '0.00';
          }
          this[currentData] = val;
        }

        if (!Number(val) && val != '0.00' && val != '0') {
          //if val is a not valid number and val not 0.00 or 0 then show error message
          this[`${currentData}Error`] = 'Value Invalid!';
        } else {
          if (currentData == 'qty') {
            this[currentData] = val;
          } else {
            this[currentData] = Number(val).toFixed(2);
          }
          switch (currentData) {
            case 'qty': //qty changes replace all money value
              this.buyingUPrice = (Number(this.buying) / val).toFixed(2);
              this.buying = (Number(this.buyingUPrice) * val).toFixed(2);
              this.sellingUPrice = (Number(this.selling) / val).toFixed(2);
              this.selling = (Number(this.sellingUPrice) * val).toFixed(2);
              break;
            case 'buyingUPrice': //buying u price change total price
              this.buying = (Number(val) * this.qty).toFixed(2);
              break;
            case 'buying': //buying total change u price
              this.buyingUPrice = (Number(val) / this.qty).toFixed(2);
              break;
            case 'sellingUPrice': //selling u price change total price
              this.selling = (Number(val) * this.qty).toFixed(2);
              break;
            case 'selling': //selling total change u price
              this.sellingUPrice = (Number(val) / this.qty).toFixed(2);
              break;
          }
        }
      }
    },

    quotationCaptionLostFocus: async function (state, key) {
      if (!state) {
        await this.$nextTick();
        const cust = this.selectedCustomer ? this.selectedCustomer['Customer Code'] : (this.freeTextCustomer ?? '');
        this.freeTextQuotation = `${cust}${this.pod ?? ''}${this.cargotype ?? ''}${this.size ?? ''}${this.extra ?? ''}`;
        if (this.freeTextQuotation.length > 25) {
          this.$showAlert('warning', 'Quotation # length exceed', 'Quotation # cannot exceed 25 characters');
          const minusLength = this.freeTextQuotation.length - 25;
          if (key) {
            if (key == 'freeTextCustomer') {
              this.freeTextCustomer = '';
              this.selectedCustomer = null;
            }
            this[key] = this[key].substring(0, this[key].length - minusLength);
          }
        }
        this.quotationnoError = '';
      }
    },

    quotationDetailsJSONFormat: function () {
      //for formatting JSON to populate in Report Designer
      const formattedJSON = JSON.parse(JSON.stringify(this.quotationDetails[0]));

      formattedJSON['Customer Name'] = this.selectedCustomer?.['Customer Name'] ?? '';
      formattedJSON['Date'] = new Date().formatString('yyyy-MM-dd');
      formattedJSON['HeaderImage'] = this.headerImage;
      if (formattedJSON['DefaultChargesList'].length > 0) {
        formattedJSON['DefaultChargesList'].forEach((d) => {
          d['Charges'] = `RM ${d['Selling']}`;
          if (d['UOM']) {
            d['Charges'] = `${d['Charges']} / ${d['UOM']}`;
          }
        });
      }
    },

    chargesPopUpClick: function () {
      this.resetChargesInput();

      //for eQuotation default certain value
      this.startValidDate = this.eQuoteShipmentDateFrom;
      this.endValidDate = this.eQuoteShipmentDateTo;

      this.chargesPopUp = !this.chargesPopUp;
    },

    deletePopUpClick: function () {
      if (this.selectedCharges.length > 0) {
        const temp = JSON.parse(JSON.stringify(this.defaultChargesList));
        this.selectedCharges.forEach((e) => {
          const delIndex = temp.findIndex((i) => i['ID'] == e['ID']);
          if (delIndex != -1) {
            if (e['indaction'] == 'N') {
              temp.splice(delIndex, 1);
            } else {
              e['indaction'] = 'D';
              temp.splice(delIndex, 1, e);
            }
          }
        });
        this.defaultChargesList = [];
        this.selectedCharges = [];
        this.$nextTick(() => (this.defaultChargesList = JSON.parse(JSON.stringify(temp))));
      } else {
        this.$showAlert('warning', 'Delete Default Charges', 'Please select a record to delete');
      }
    },

    defaultChargesTableEditButtonClick: async function (_btn, data) {
      this.chargesPopUp = true;
      this.selectedEditID = data['ID'];
      this.seqNo = data['SeqNo'];
      this.editDisabled = true;
      const tempChargesCode = this.chargesCodeList.getSelected(data['Charge Code'], 'Charge Code');
      this.selectedChargesType = this.chargesCodeType.getSelected(tempChargesCode['Payable'], 'type');
      this.chargesTypeSelected(this.selectedChargesType);
      this.selectedChargesCode = this.filteredChargesCodeList.getSelected(
        tempChargesCode['Charge Code'],
        'Charge Code',
      );
      this.selectedCurrency = this.currencyList.getSelected(data['Currency'], 'Currency Code');
      this.qty = data['Qty'] ? parseFloat(data['Qty']).toString() : '';
      this.selectedUOM = this.uomList.getSelected(data['UOM'], 'UOM Code');
      this.selectedUOMType = this.uomTypeList.getSelected(data['UOM Type'], 'UOMType');
      this.uomRangeFrom = data['UOM Range'].split('-')[0];
      this.uomRangeTo = data['UOM Range'].split('-')[1];
      this.buying = data['Buying'];
      this.selling = data['Selling'];
      this.qtyBuySellLostFocus(false, 'qty');
      this.selectedPayeeType = this.payeeTypeList.getSelected(data['Payee Type'], 'party_code');
      this.selectedPayeeCode = this.payeeCodeList.getSelected(data['Payee Code'], 'Payee Code');
      this.selectedEditPayeeCode = this.payeeCodeList.getSelected(data['Payee Code'], 'Payee Code');

      if (data['Start Valid Date']) {
        this.startValidDate = new Date(data['Start Valid Date']);
      }
      if (data['End Valid Date']) {
        this.endValidDate = new Date(data['End Valid Date']);
      }
      // this.startValidDate = data['Start Valid Date'];
      // this.endValidDate = data['End Valid Date'];
      this.itemremarks = data['Item Remarks'];
      await this.$nextTick();
    },

    generateReportJSON: function () {
      return {
        'Quotation No': this.freeTextQuotation,
        'Customer Code': this.selectedCustomer?.['Customer Code'] ?? '',
        POD: this.pod,
        'Cargo Type': this.cargotype,
        Size: this.size,
        Extra: this.extra,
        Remarks: this.remarks,
        DefaultChargesList: this.defaultChargesListWithoutDelete.map((item) => ({
          ...item,
          Qty: parseFloat(item.Qty).toString(),
        })),
      };
    },

    generateReport: function () {
      if (!this.freeTextQuotation || this.defaultChargesList.length <= 0) {
        if (!this.freeTextQuotation) {
          this.quotationnoError = 'Quotation # is compulsory!';
        }
        if (this.defaultChargesList.length <= 0) {
          this.$showAlert('error', 'Generate Report', 'Must have at least 1 default charges');
        }
        return;
      }
      this.designerV3ReportFile = null;
      //for formatting JSON to populate in Report Designer
      const formattedJSON = JSON.parse(JSON.stringify(this.generateReportJSON()));
      formattedJSON['Customer Name'] =
        this.selectedCustomer ? this.selectedCustomer?.['Customer Name'] : this.freeTextCustomer;
      // formattedJSON['Customer Name'] = this.freeTextCustomer ?? '';
      formattedJSON['Date'] = new Date().formatString('yyyy-MM-dd');
      formattedJSON['HeaderImage'] = this.headerImage;
      if (formattedJSON['DefaultChargesList'].length > 0) {
        formattedJSON['DefaultChargesList'].forEach((d) => {
          d['Charges'] = `RM ${d['Selling']}`;
          if (d['UOM']) {
            d['Charges'] = `${d['Charges']} / ${d['UOM']}`;
          }
        });
      }
      this.designerV3Data = [formattedJSON];
      this.designerV3ReportFile = ['Quotation.json'];
    },

    refresheQuotation: async function () {
      this.$loading('Getting eQuotation Listing');
      this.equotationListing = [];
      this.selectedeQuotation = null;
      await this.$nextTick();
      this.equotationListing = await this.$apiCallV2('/Quotation/GeteQuotationListing', {});
      this.eQuotationLastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm');
      this.$loading('');
    },

    accepteQuotation: async function () {
      this.eQuoteShipmentDateFrom = null;
      this.eQuoteShipmentDateTo = null;

      if (this.selectedeQuotation) {
        if (this.selectedeQuotation[0]['quotationno']) {
          const editAnswer = await this.$showAlert(
            'warning',
            'eQuotation Already Accepted',
            `Do you want to edit the Quotation #(${this.selectedeQuotation[0]['quotationno']}) Revision(${this.selectedeQuotation[0]['revisionno']})`,
            [
              { text: 'Yes', color: 'green', textColor: 'white' },
              { text: 'No', color: 'gray', textColor: 'white' },
            ],
          );

          if (editAnswer == 'Yes') {
            this.$loading('Getting Data');
            this.action = 'E';
            this.selectedQuotation = this.quotationList.getSelected(
              this.selectedeQuotation[0]['quotationno'],
              'Quotation #',
            );
            await this.populateQuotation(
              this.selectedeQuotation[0]['quotationno'],
              this.selectedeQuotation[0]['revisionno'],
            );
            this.quotationDetailsJSONFormat();
            this.showDefaultCharges = false;
            this.showReportsHome = true;
            this.$loading('');
          }
        } else {
          this.quotationDate = new Date();
          this.referenceNo = this.selectedeQuotation[0]['RFQ #'];
          this.selectedCustomer = this.customerList.getSelected(
            this.selectedeQuotation[0]['cunumber'],
            'Customer Code',
          );
          this.freeTextQuotation = this.referenceNo;
          this.revisionNo = '0';
          this.containerType = this.selectedeQuotation[0]['Container Code'];
          this.dgCargo = this.selectedeQuotation[0]['DG Cargo'] != 'No';
          this.selectedIncoterm = this.incotermList.getSelected(this.selectedeQuotation[0]['Incoterm'], 'Incoterm');
          this.freetime = this.selectedeQuotation[0]['Freetime'];
          this.selectedPOL = this.polList.getSelected(this.selectedeQuotation[0]['portloadcode'], 'Port Code');
          this.selectedPOD = this.podList.getSelected(this.selectedeQuotation[0]['portdischargecode'], 'Port Code');
          this.selectedFinalDestination = this.finalDestinationList.getSelected(
            this.selectedeQuotation[0]['finaldestcode'],
            'Port Code',
          );

          this.eQuoteShipmentDateFrom =
            this.selectedeQuotation[0]['Shipment Date From'] ?
              new Date(this.selectedeQuotation[0]['Shipment Date From'])
            : null;
          this.eQuoteShipmentDateTo =
            this.selectedeQuotation[0]['Shipment Date To'] ?
              new Date(this.selectedeQuotation[0]['Shipment Date To'])
            : null;

          await this.menuClicked({ title: 'New Default Charges' });
        }
      } else {
        this.$showAlert('error', 'eQuotation Selection', 'No eQuotation Selected');
      }
    },

    sendeQuotation: function () {
      this.$loading('Sending eQuotation');
      if (this.selectedeQuotation[0]['Status'] == 'sent') {
        this.$showAlert('error', 'eQuotation Sent', `${this.selectedeQuotation[0]['RFQ #']} already sent. `);
      } else if (!this.selectedeQuotation[0]['Status']) {
        this.$showAlert(
          'error',
          'eQuotation Not Created',
          `${this.selectedeQuotation[0]['RFQ #']} has not yet been accepted. `,
        );
      } else {
        this.sendeQuotationAPI(this.selectedeQuotation[0]['RFQ #']);
      }
      this.$loading('');
    },

    sendeQuotationAPI: async function (requestNo) {
      const result = await this.$apiCallV2('/Quotation/KLKQuoteCreate', { requestno: requestNo });
      if (result) {
        this.$showAlert(
          result[0]['Results'] == 0 ? 'success' : 'error',
          'Send eQuotation',
          `eQuotation sent ${result[0]['Results'] == 0 ? 'successfully' : 'failed'}\n${result[0]['ErrMsg']}`,
        );
      }
    },

    chargesTypeSelected(newSelected, oldSelected) {
      if (oldSelected === newSelected) {
        return;
      }

      this.selectedChargesCode = null;
      if (newSelected) {
        this.filteredChargesCodeList = this.chargesCodeList.filter(
            (f) => f['Payable'] == newSelected['type'],
          );
      } else {
        this.filteredChargesCodeList = [];
      }
    },
  },
  async mounted() {
    await this.sasControlFunction();
    await this.refreshClicked();

    let mountedPromises = [];
    let promisesFulfilled = 0;

    const populateDataPromises = this.populateData().map((promise) => {
      return promise.then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      });
    });
    mountedPromises = mountedPromises.concat(populateDataPromises);

    //to hide the additional details section
    mountedPromises.push(
      this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=6GQuotation_ADDDET').then((result) => {
        const hideAddDet = result?.[0]?.SettingsValue;
        if (hideAddDet == '1') {
          this.showAdditionalDetails = true;
        }
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    await Promise.allSettled(mountedPromises).then((_promiseOutcomes) => {
      this.menu = this.menu.map((menu) => {
        menu.enabled = true;
        return menu;
      });
    });
  },
  watch: {
    selectedPayeeType: function (val) {
      this.selectedPayeeCode = null;
      if (this.selectedEditPayeeCode) {
        this.selectedPayeeCode = this.selectedEditPayeeCode;
      }
      if (val) {
        this.filteredPayeeCodeList = this.payeeCodeList.filter((p) => p['Payee Type'] == val['party_code']);
      }
    },
    selectedQuotation: function (val) {
      if (!this.currentQuotation) {
        this.currentQuotation = JSON.parse(JSON.stringify(val));
      }
    },
    draftPopUp: function (val) {
      if (val) {
        this.loadDraftButtonClick();
      }
    },
    draftSavePopUp: function (val) {
      if (val) {
        this.loadDraftFileHistory();
        this.draftFileName = this.freeTextQuotation;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.default-charges {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 10px 10px 45px;
  display: flex;

  > .left-menu {
    display: flex;
    justify-content: center;
  }

  > .right-tabulator {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    width: 100%;
    margin-left: 5px;
    overflow: hidden;
  }

  > .equotation-popup {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.5);
    top: 50px;
    left: 0px;
    height: calc(100% - 50px);
    width: 100%;
    z-index: 199;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > .equotation-content {
      background-color: lightgray;
      padding: 5px;
      left: 20px;
      width: calc(100% - 55px);
      height: calc(100% - 20px);
      position: relative;
      display: flex;
      flex-direction: column;

      > .top-section,
      > .table-section,
      > .bottom-section {
        background-color: white;
        border-radius: 5px;
        padding: 5px;
      }

      > .top-section,
      > .bottom-section {
        display: flex;
        justify-content: flex-end;
      }

      > .top-section {
        align-items: center;

        > :first-child {
          margin-right: 5px;
        }

        > :last-child {
          margin-left: 5px;
        }
      }

      > .table-section {
        height: 100%;
        margin-top: 5px;
        overflow: hidden;
      }

      > .bottom-section {
        margin-top: 5px;

        > button {
          margin-left: 5px;
          color: white;
        }

        > :nth-child(1) {
          color: black;
        }

        > :nth-child(2) {
          background-color: green;
        }

        > .cancel-btn {
          background-color: gray;
        }
      }
    }
  }
}

.quotation-main {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 10px 10px 45px;

  .Details_Quotation {
    > .Details_Quotation_smalldiv {
      border: 1px solid black;
      border-radius: 5px;
      padding: 5px;
      padding-top: 10px;
      margin: 5px;
      margin-top: 5px;
      position: relative;

      > .Details_Quotation_title {
        position: absolute;
        top: -10px;
        background-color: white;
        padding: 0 10px;
        left: 10px;
      }
    }

    > .defaultChargesTable {
      height: 290px;
    }

    > .Details_New,
    .addDeleteButton,
    .saveButton {
      display: flex;
      justify-content: flex-end;

      > button {
        margin: 0 3px 0 3px;
      }
    }
    > .saveButton {
      > button {
        margin-top: 3px;
      }
    }
  }

  .buySell,
  .uomFromTo,
  .validStartEnd {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .popupBuying,
  .popupSelling,
  .uomRangeFromTo,
  .startEndValid {
    border: 1px solid black;
    border-radius: 5px;
    padding: 5px;
    padding-top: 10px;
    margin: 5px;
    margin-top: 15px;
    position: relative;

    > .buying,
    .selling,
    .uomRange,
    .valid {
      position: absolute;
      top: -10px;
      background-color: white;
      padding: 0 10px;
      left: 10px;
    }
  }

  > .chargesPopUp {
    ::v-deep {
      // deep needed to target the content class inside the PopupV2 component
      .content {
        // NOT the content class for slot, but content class inside PopupV2 itself
        text-align: left;
      }
    }
  }

  .chargesPopUp-Main {
    padding: 5px;
  }

  .draftPopUpBody {
    padding: 5px;
  }
}

@media only screen and (max-width: 900px) {
  .Quo-Cus {
    display: flex;
    flex-direction: column;
  }
  // .quotation-main {

  //   > .Details_Quotation {

  //     > .Details_Quotation_smalldiv {

  //       > .Quo-Cus {
  //         display: flex;
  //         flex-direction: column;
  //       }
  //     }
  //   }
  // }
}
</style>
